// Shared global keyframe for in-component loading spinners. Components call
// `ensureSpinStyle()` once (typically in a top-level useEffect or render) and
// then use `style={{ animation: SPIN_ANIMATION }}` on a Lucide icon to animate
// it. Idempotent — safe to call from multiple components on the same page.

export const SPIN_ANIMATION = 'crewvex-spin 1s linear infinite';

const SPIN_STYLE_ID = 'crewvex-spin-anim';

export function ensureSpinStyle() {
  if (typeof document === 'undefined') return;
  if (document.getElementById(SPIN_STYLE_ID)) return;
  const s = document.createElement('style');
  s.id = SPIN_STYLE_ID;
  s.textContent =
    '@keyframes crewvex-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }';
  document.head.appendChild(s);
}
